module.exports = __webpack_public_path__ + "static/media/passos.c15dbd24.svg";